import { render, staticRenderFns } from "./PageMain.vue?vue&type=template&id=77a9c001&scoped=true"
import script from "./PageMain.vue?vue&type=script&lang=js"
export * from "./PageMain.vue?vue&type=script&lang=js"
import style0 from "./PageMain.vue?vue&type=style&index=0&id=77a9c001&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a9c001",
  null
  
)

export default component.exports